import { createContext, useContext } from 'react';

export interface TileCoordinates {
	row: number;
	col: number;
}

type TileHoverContext = {
	coords: TileCoordinates | null;
	setTileCoordinates(coords: TileCoordinates | null): void;
};

const context = createContext<TileHoverContext | null>(null);

export function useTileHoverContext(): TileHoverContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useTileHoverContext must be used within a TileHoverContextProvider');
	}

	return contextValue;
}

export const TileHoverContextConsumer = context.Consumer;
export const TileHoverContextProvider = context.Provider;
